import { BuyItAgainItem, PriceDefault, PriceRange } from '@libs/common-types';

export function resolvePrice(price: BuyItAgainItem['price']): number {
    if (price.type === 'range') {
        const rangePrice: PriceRange = price;
        const value = rangePrice.sale?.to ?? rangePrice.original.to;
        return Number.parseFloat(value.replace('$', ''));
    }

    const defaultPrice: PriceDefault = price;
    const value = defaultPrice.sale ?? defaultPrice.original;
    return Number.parseFloat(value.replace('$', ''));
}
